"use client";
import CTA from "@/components/CTA";
import type { CTAComponentProps } from "@/components/CTA/types";
import PromoBanner from "@/components/PromoBanner";
import { MonarchDataConsumer } from "@/monarch/MonarchDataConsumer";
import MonarchResolver from "@/monarch/MonarchResolver";
import type { HomepagePromoBannerTestResult } from "@/monarch/rules/homepagePromoBanner/types";

function PromoBannerComponent() {
  return (
    <MonarchDataConsumer<HomepagePromoBannerTestResult>
      experimentKey="useHomepagePromoBanner"
      render={(testResult) => {
        const { data } = testResult;
        if (!data) {
          return null;
        }
        const cta = data.cta
          ? {
              ...data.cta,
              location: "homepage-promo-banner",
              html_id: "homepage-promo-banner-cta",
            }
          : undefined;
        return (
          <PromoBanner
            {...data}
            cta={cta}
            className="not-prose fullwidth py-0"
          />
        );
      }}
    />
  );
}

export default function HomepagePromoBanner(props: CTAComponentProps) {
  return (
    <MonarchResolver<HomepagePromoBannerTestResult>
      experimentKey="useHomepagePromoBanner"
      variants={{
        control: <CTA {...props} />,
        homepagePromoBannerControl: <CTA {...props} />,
        homepagePromoBannerVariantA: <PromoBannerComponent />,
      }}
      fallbackVariant="control"
    />
  );
}
